import { useState, useEffect } from "react";

import { useLogin } from "../../login/context/LoginContext";
import { handleBankID } from "../../../api/services/login";

import { Text, Button, Icon } from '@virkesborsen/ui-component-library';
import IconAnimate from '../../../assets/treebula/IconAnimated';

export default function LoginBankid() {
    const LoginContext = useLogin();
    
    const [sessionID, setSessionID] = useState(null);
    const [message, setMessage] = useState(null);
    const [autoStartToken, setAutoStartToken] = useState(null);
    const [qr, setQr] = useState(null);

    useEffect(() => {
        const updateBankID = setInterval(() => {
            handleBankIDLogin();
        }, 2000);
        
        if(message && message.status === 'failed') {
            if(message.hintCode === 'bankid_already_linked_to_user') {
                setTimeout(() => {LoginContext.close(false)}, 3000)
            }
            clearInterval(updateBankID);
        }

        if(message && message.status === 'success') {
            clearInterval(updateBankID);
        }

        return () => clearInterval(updateBankID);
    }, [sessionID, message])

    useEffect(() => {
        handleBankIDLogin()
    }, [])

    const handleBankIDLogin = async () => {
        const email = LoginContext.isLogged ? LoginContext.data.email : null
        const resp = await handleBankID(email, sessionID)

        if(resp.ok) {
            resp.data.auto_start_token && setAutoStartToken(resp.data.auto_start_token)
            resp.data.message && setMessage(resp.data.message)
            setSessionID(resp.data.session_id)
            setQr(resp.data.svg_image)

            if(resp.data?.message && resp.data.message.status === 'success') {
                let data = {}
                resp.data.ssn && (data.ssn = resp.data.ssn)
                resp.data.user_email && (data.email = resp.data.user_email)
                resp.data.user_id && (data.user_id = resp.data.user_id)

                await LoginContext.setData(prev => ({...prev, ...data}))
                if(data.user_id) {
                    LoginContext.onLogin(data.user_id)
                }

                setTimeout(() => {
                    if(data.user_id) {
                        gtag('event', 'login', { method: 'site' });
                        mixpanel.track("login_success_fe", {login_method: 'bankid'}) 
                        LoginContext.close(false)
                    } else {
                        mixpanel.track("login_register_attempt_fe", {login_method: 'bankid'})
                        LoginContext.setView('main')
                    }
                }, 1000)
            }
        } else {
            alert('Oops! Något gick fel. Ring 08-33 99 44 så hjälper vi dig vidare.')
            LoginContext.setView('start')
        }
    }

    const hintcodeMessage = (hintCode) => {
        switch (hintCode) {
            case 'userSign':
                return 'Skriv in din säkerhetskod i BankID-appen och välj Legitimera.'
            case 'startFailed':
                return 'Inloggningen avbröts, eller tog för lång tid. Av säkerhetsskäl finns det en tidsbegränsning.'
            case 'userCancel':
                return 'Identifieringen avbröts från BankID-appen.'
            case 'bankid_already_linked_to_user':
                return 'BankID-inloggningen misslyckades. Vi hänvisar dig vidare – vänligen kontakta vår support om problemet kvarstår.'
            default:
                return 'Unkown error'
        }
    }

    return <>
        <div className='flex justify-between w-fill mb-2'>
            <Icon tw name='BankIdSimple' size='xlarge' />

            <Icon tw name='CrossSimple' className='cursor-pointer' size='large'  onClick={() => LoginContext.isLogged ? LoginContext.close(false) : LoginContext.setView('start')} />
        </div>

        {message && message.status === 'success' ? <>
            <Text variant='labelLargeMedium' className='mt-4'>Verifiering klar, du skickas vidare...</Text>
        </> : <>
            <Text variant='labelLargeMedium'>Legitimera med BankID</Text>
            
            {(!message || message.hintCode === 'outstandingTransaction') && <>
                <div className='flex justify-center my-5'>
                    <div className='relative rounded-2xl shadow-xl max-w-md mx-auto'>
                        {qr ? <div className='flex' dangerouslySetInnerHTML={{ __html: qr }}></div> : <div className='flex justify-center items-center' style={{width: '196px', height: '196px'}}><div class="size-16 border-6 border-charcoal-500 border-t-transparent border-solid rounded-full animate-spin"></div></div>}

                        <div class="absolute top-0 left-0 w-10 h-10 border-t-2 border-l-2 border-charcoal-500 border-solid rounded-tl-lg"></div>
                        <div class="absolute top-0 right-0 w-10 h-10 border-t-2 border-r-2 border-charcoal-500 border-solid rounded-tr-lg"></div>
                        <div class="absolute bottom-0 left-0 w-10 h-10 border-b-2 border-l-2 border-charcoal-500 border-solid rounded-bl-lg"></div>
                        <div class="absolute bottom-0 right-0 w-10 h-10 border-b-2 border-r-2 border-charcoal-500 border-solid rounded-br-lg"></div>
                    </div>
                </div>

                <div className='flex'>
                    <Text variant='bodySmallRegular' className='mt-2 text-charcoal-500 w-4' >1.</Text>
                    <Text variant='bodySmallRegular' className='mt-2 text-charcoal-500'>Öppna BankID-appen på din mobil och klicka på QR-ikonen.</Text>
                </div>

                <div className='flex'>
                    <Text variant='bodySmallRegular' className='mt-2 text-charcoal-500 w-4'>2.</Text>
                    <Text variant='bodySmallRegular' className='mt-2 text-charcoal-500'>Rikta kameran mot QR-Koden som visas här på skärmen.</Text>
                </div>
                
                {autoStartToken && <Button tw variant='primary' onClick={() => window.location.href = `bankid:///?autostarttoken=${autoStartToken}&redirect=null`} className='mt-8' fullWidth>BankID på den här enheten</Button>}
            </>}
                
            {message && message.hintCode != 'outstandingTransaction' && <>
                {message.status === 'failed' ?<div className='flex justify-center items-center w-full'>
                    <div className='flex justify-center items-center rounded-full aspect-square bg-red-scarlet-50 my-16' style={{height: '60px', width: '60px'}}>
                        <Icon name='CrossSimple' color='red-scarlet-500' size="xlarge" />
                    </div>
                </div> :
                <div className='flex justify-center my-16'>
                    <IconAnimate style={{width: '90px'}} />
                </div>}

                <Text className='text-pebble-500 text-center mb-4' variant='introLeadSmallRegular'>{hintcodeMessage(message.hintCode)}</Text>
            </>}

            <Button tw variant='secondary' onClick={() => LoginContext.isLogged ? LoginContext.close(false) : LoginContext.setView('start')} className='mt-2' fullWidth>Avbryt</Button>
        </>}
    </>
}
